import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getAuthToken } from "../../utils/auth";
import { handleApiError } from "../handleApiError";

const API_URL = process.env.REACT_APP_API_URL;

// ========================
// START CHAT
// POST /chat
// ========================
export const startChat = createAsyncThunk(
  "chat/start",
  async ({ companyId }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      // console.log(token);
      // console.log(companyId);
      const res = await axios.post(
        `${API_URL}/chat/${companyId}`,
        {},
        {
          headers: { Authorization: `${token}` },
        },
      );
      // console.log(res);
      return res.data.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ========================
// GET MY CHATS (USER)
// GET /chat/my-chats
// ========================
export const getMyChats = createAsyncThunk(
  "chat/myChats",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.get(`${API_URL}/chat/my-chats`, {
        headers: { Authorization: `${token}` },
      });
      // console.log(res);
      return res.data.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ========================
// GET COMPANY CHATS (OWNER)
// GET /chat/my-chats-company
// ========================
export const getCompanyChats = createAsyncThunk(
  "chat/companyChats",
  async (_, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.get(`${API_URL}/chat/my-chats-company`, {
        headers: { Authorization: `${token}` },
      });
      // console.log(res);
      return res.data.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ========================
// SEND MESSAGE
// POST /chat/:id/messages
// ========================
export const sendMessage = createAsyncThunk(
  "chat/sendMessage",
  async ({ chatId, content }, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.post(
        `${API_URL}/chat/${chatId}/messages`,
        { content },
        {
          headers: { Authorization: `${token}` },
        },
      );
      return res.data.data;
    } catch (error) {
      handleApiError(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// ========================
// GET CHAT MESSAGES
// GET /chat/:id/messages
// ========================
export const getChatMessages = createAsyncThunk(
  "chat/getMessages",
  async (chatId, { rejectWithValue }) => {
    try {
      const token = getAuthToken();
      const res = await axios.get(`${API_URL}/chat/${chatId}/messages`, {
        headers: { Authorization: `${token}` },
      });
      return res.data.data || [];
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
